/**
 * Contact Info Row
 *  This is custom component for contact information in a card component
 */
import { Tooltip, createStyles, makeStyles } from '@material-ui/core';
import CopyToClipboard from 'react-copy-to-clipboard';
import React, { useState } from 'react';
import { EnvelopeIcon, PhoneIcon } from '../Icons';
import { Typography } from '../Typography';
const useStyles = makeStyles((theme) => createStyles({
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        color: theme.palette.text.secondary,
    },
    icon: {
        fontSize: theme.spacing(3),
    },
    phoneWrapper: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    emailWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: theme.spacing(1),
        cursor: 'pointer',
    },
    phoneNumber: {
        marginLeft: theme.spacing(2),
    },
}));
const ContactInfoRow = ({ phone, email }) => {
    const classes = useStyles();
    const [phoneTooltipText, setPhoneTooltipText] = useState('Copy');
    const [emailTooltipText, setEmailTooltipText] = useState('Copy');
    const copyPhone = () => {
        setPhoneTooltipText('Copied');
        resetCopyToolTip(setPhoneTooltipText);
    };
    const copyEmail = () => {
        setEmailTooltipText('Copied');
        resetCopyToolTip(setEmailTooltipText);
    };
    const resetCopyToolTip = (cb) => {
        setTimeout(() => {
            cb('Copy');
        }, 1000);
    };
    return (React.createElement("div", { className: classes.wrapper },
        phone && (React.createElement(CopyToClipboard, { onCopy: copyPhone, text: phone },
            React.createElement(Tooltip, { title: phoneTooltipText, placement: 'right' },
                React.createElement("div", { className: classes.phoneWrapper },
                    React.createElement(PhoneIcon, { className: classes.icon }),
                    React.createElement(Typography, { variant: "caption", className: classes.phoneNumber }, phone))))),
        email && (React.createElement(CopyToClipboard, { onCopy: copyEmail, text: email },
            React.createElement(Tooltip, { title: emailTooltipText, placement: phone ? 'left' : 'right' },
                React.createElement("div", { className: classes.emailWrapper },
                    React.createElement(EnvelopeIcon, { className: classes.icon })))))));
};
export default ContactInfoRow;
//# sourceMappingURL=ContactInfoRow.js.map